export default __webpack_public_path__ + "static/media/episode-4.df7486a6.jpg";